import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import "../Styles/CustomToast.css"

export const CustomWarningToast = ({onClose, duration, emptyColumnIndex }) => {
    return (
        <div className="custom-toast">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <WarningIcon style={{ marginRight: '10px', color: '#FFC107' }} />
                <span>
                    You have a gap in your data!<br />
                    Add at least one property to Level-{emptyColumnIndex + 1}.
                </span>
            </div>
            <CloseIcon 
                onClick={onClose} 
                style={{ cursor: 'pointer', color: 'black' }} 
            />
            <div className="timer-bar" style={{ animationDuration: `${duration}ms` }} />
        </div>
    );
};
